import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import s from '../../controllers/Step2Step3Ctrl/step2Step3Ctrl.module.css';
import ReturnOptions from '../ReturnOptions';
import { ReturnMethods } from '../../components/ReturnMethod';
import BackButton from '../BackButton';
import Footer from '../../components/Footer';
import { Breadcrumb } from '../../components/Breadcrumb';
import { ReturnsButton } from '../../components/ReturnsButton';

const mapStateToProps = ({
  language,
  page: { step2Complete, productType } = {},
  stripe: { completedPayment },
  returnsSettings: {
    [productType]: { returnOptions: { enabled: returnOptionsEnabled = false } = {} } = {},
  },
  refunds: { isLoading } = {},
  returnOptions: {
    selectedOptionMethodKey,
    isReturnProhibited,
    returnOptionMethods: {
      [selectedOptionMethodKey]: { return_cost: { service_fee: serviceFee } = {} } = {},
    } = {},
  } = {},
  addresses: { hasInvalidShippingAddressForm } = {},
}) => ({
  language,
  step2Complete,
  returnOptionsEnabled,
  hideNextButton: serviceFee > 0 && !completedPayment,
  isLoading,
  isReturnProhibited,
  hasInvalidShippingAddressForm,
});

const ReturnMethodsComponent = ({
  language,
  step2Complete,
  returnOptionsEnabled,
  hideNextButton,
  navigateToStep,
  toStep3,
  isLoading,
  isReturnProhibited,
  hasInvalidShippingAddressForm,
}) => (
  <React.Fragment>
    <div
      className={
        returnOptionsEnabled ? s.step_2_return_options_container : s.step_2_inner_container
      }
    >
      <Breadcrumb navigateToStep={navigateToStep} currentStep={2} />
      <div className={s.step_2_header_container}>
        <h2
          className="step-2-header"
          dangerouslySetInnerHTML={{ __html: language['returns.step_2.header'] }}
          aria-hidden="true"
        />
        <h5
          className="step-2-subheader"
          dangerouslySetInnerHTML={{ __html: language['returns.step_2.subheader'] }}
          // eslint-disable-next-line jsx-a11y/aria-role
          role="text"
        />
      </div>
      {isReturnProhibited && (
        <div className={s.step_2_return_prohibited_container}>
          <p
            className={s.step_2_return_prohibited_message}
            dangerouslySetInnerHTML={{
              __html: language['returns.step_2.return_prohibited_message'],
            }}
          />
        </div>
      )}
      {returnOptionsEnabled && (
        <return-options>
          <ReturnOptions toStep3={toStep3} />
        </return-options>
      )}
      <ReturnMethods toStep3={toStep3} />
      {!hideNextButton && (
        <div className={cx(s.button_container)}>
          <returns-button>
            <ReturnsButton
              tier="primary"
              big
              loading={isLoading}
              onClick={() => toStep3()}
              disabled={!step2Complete || isLoading || isReturnProhibited || hasInvalidShippingAddressForm}
            >
              {language['returns.step_1.next_button']}
            </ReturnsButton>
          </returns-button>
          {!isLoading && (
            <back-button>
              <BackButton onClick={() => navigateToStep(1)} />
            </back-button>
          )}
        </div>
      )}
    </div>
    <returns-footer className={s.footer}>
      <Footer />
    </returns-footer>
  </React.Fragment>
);

ReturnMethodsComponent.propTypes = {
  language: PropTypes.object.isRequired,
  step2Complete: PropTypes.bool.isRequired,
  returnOptionsEnabled: PropTypes.bool.isRequired,
  hideNextButton: PropTypes.bool.isRequired,
  navigateToStep: PropTypes.func.isRequired,
  toStep3: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isReturnProhibited: PropTypes.bool.isRequired,
  hasInvalidShippingAddressForm: PropTypes.bool.isRequired,
};

export const ReturnMethodsPage = connect(mapStateToProps)(ReturnMethodsComponent);
